export default "__VITE_ASSET__URpw6c3k__"